import React from 'react'
import { Title } from './Title'
import './allCategories.scss'
import { useAllCategoriesQuery } from '../../hooks/useAllCategoriesQuery'
import { Label } from './Label'
import { Link } from '../global'

/**
 * Displays a list of categories excluding specified ones.
 *
 * @param {string} props.activeSlug - The slug of the currently active category.
 * @returns {JSX.Element} - React JSX element showing the filtered category list.
 */
export const AllCategories = ({ activeSlug, showBlogg }) => {
  const data = useAllCategoriesQuery()

  if (data?.length) {
    const categories = data.filter(
      category =>
        ![!showBlogg && 'bloggar', 'uncategorized', activeSlug].includes(
          category.node.slug,
        ),
    )

    return (
      <div className="all-categories">
        <Title text="Fler kategorier" />

        <div className="container">
          {categories.map(category => (
            <Link key={category.node.id} to={category.node.uri}>
              <Label
                text={category.node.name}
                backgroundColor="gray"
                textColor="white"
                size="sl"
              />
            </Link>
          ))}
        </div>
      </div>
    )
  }
}
